module.exports = __webpack_public_path__ + "static/media/BNM.46df7641.jpg";